<template>
    <div class="l-container-content bg-white">
        <div class="row">
            <div class="col-6">
                <h3>All Pending Payments</h3>
            </div>
            <div class="col-6 text-right">
                <button @click="showModal" class="button primary">Payment Retry</button>
            </div>
        </div>
        <div class="row">
            <loader v-show="loading" />
            <vuetable ref="vuetable" :http-options="httpOptions" :api-url="url" :fields="columns" :sort-order="sortOrder" track-by="msisdn" :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationData" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                <div slot="gTypeStatus" slot-scope="props">
                    <div :class="props.rowData.gTypeStatus | gamesClassStatus"><strong>{{props.rowData.gTypeStatus | gamesStatus}}</strong></div>
                </div>
                <div slot="gTypeId" slot-scope="props">
                    <strong>{{props.rowData.gTypeId | gameCategoryID}}</strong>
                </div>
    
            </vuetable>
           
        </div>
        <div class="vuetable-pagination ui basic segment grid row">
            <div class="col text-left">
                <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
            </div>
            
            <div class="col-6  text-right">
                <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
            </div>
            
        </div>
        <b-modal ref="ussd-payment" hide-footer title="Payment Retry">
          
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div class="mb-3">
          <label for="name" class="form-label">Limit</label>
          <input type="number" v-model="limitReq" class="form-control"  required>
        </div>
            
            <div class="mb-3">
                <b-button  variant="outline-success" block @click="proceedRetry">Proceed to Retry </b-button>
            </div>
            
        </b-modal>
    </div>
</template>

<style>
td.vuetable-slot {
    overflow: visible !important;
}
</style>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import loader from "@/components/loader";
import store from "../store";
import $ from 'jquery'

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        loader
    },
    name: "approvals",
    data() {
        return {
            limitReq: 5,
            errorcreateStatus: false,
            errorsMessage: "",
            loading: true,
            loadRecord: false,
            selected_data: {},
            url: "https://interactiveapi.chezagame.com/v1/spinwheel/ussd/payment/retry/view",
            httpOptions: {
                headers: {
                    'X-App-Key': '09lib74145Qb3HO6eQTIfsbylRkyuZFT',
                    'X-Authorization-Key': 'ADMIN_APP',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'X-Token-Key': this.$cookies.get("accessToken")
                }
            },
            columns: [{
                    name: "request_id",
                    title: '<span class="orange glyphicon glyphicon-user"></span> Request ID',
                    sortField: "request_id",
                    titleClass: "center aligned",
                    dataClass: "center aligned"
                },

                {
                    name: "msisdn",
                    title: "Mobile",
                    sortField: "msisdn",
                    titleClass: "",
                    dataClass: ""
                },

                {
                    name: "mpesa_transaction_id",
                    title: "M-Pesa Reference",
                    sortField: "mpesa_transaction_id",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "response_status",
                    title: "Status",
                    sortField: "response_status",
                },
                {
                    name: "withdraw_amount",
                    title: "Withdraw Amount",
                    sortField: "withdraw_amount",
                },
                {
                    name: "created_at",
                    title: "Date",
                    sortField: "created_at",
                },

            ],
            range: "",
            search_match: "",
            loadOnStart: true,
            sortOrder: [{
                field: "request_id",
                direction: "desc"
            }],
            is_partial_resulting: false,

            moreParams: {
                start: "",
                filter: "",
                end: ""
            }
        };
    },

    mounted() {

        var vm = this;
        if (vm.$cookies.get("role_id") != 1 && vm.$cookies.get("role_id") != 2) {
            vm.$router.push({
                name: "dashboard"
            });
        }

        var start = moment().subtract(120, "days");
        var end = moment();

        function cb(start, end) {
            vm.dateFilter(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
            $('input[name="dates"]').val(
                start.format("D MMMM, YYYY") + " - " + end.format("D MMMM, YYYY")
            );
        }

        $('input[name="dates"]').daterangepicker({
                startDate: start,
                endDate: end,
                ranges: {
                    Today: [moment(), moment()],
                    Yesterday: [
                        moment().subtract(1, "days"),
                        moment().subtract(1, "days")
                    ],
                    "Last 7 Days": [moment().subtract(6, "days"), moment()],
                    "Last 30 Days": [moment().subtract(29, "days"), moment()],
                    "This Month": [moment().startOf("month"), moment().endOf("month")],
                    "Last Month": [
                        moment()
                        .subtract(1, "month")
                        .startOf("month"),
                        moment()
                        .subtract(1, "month")
                        .endOf("month")
                    ]
                }
            },
            cb
        );

        cb(start, end);
    },

    watch: {
        data(newVal, oldVal) {
            this.$refs.vuetable.refresh();
        },
        range() {
            var start = this.range[0];
            var end = this.range[1];
            start = moment(start).format("YYYY-MM-DD");
            end = moment(end).format("YYYY-MM-DD");
            this.moreParams.start = start;
            this.moreParams.end = end;
            this.$refs.vuetable.refresh();
        }
    },

    methods: {
        dateFilter: function(start, end) {
            var vm = this;

            vm.start = start;
            vm.end = end;

            vm.moreParams.start = start;
            vm.moreParams.end = end;

            this.$refs.vuetable.refresh();

            console.log("start date filter", start);
            console.log("end date filter ", end);
        },
        showModal() {
            this.$refs['ussd-payment'].show()
        },
        hideModal() {
            this.$refs['ussd-payment'].hide()
        },
        createdAt: function(value) {
            if (!value) {
                return "-";
            } else {
                return moment(value).format("h:mm a,DD MMM YYYY");
            }
        },
        proceedRetry() {
            let vm = this
            $.post({
                url: store.state.rootUrl + 'v1/spinwheel/ussd/payment/retry',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    limitPay: vm.limitReq
                }),
                success: function(response, status, jQxhr) {
                    // console.log(JSON.stringify(response.data.data));
                    $("#createUser").text("Create Game");
                    if (response.data.code == 200) {
                        vm.$refs.vuetable.refresh();
                        vm.hideModal()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.errorsMessage = response.data.message;
                    }


                },
                error: function(jQxhr, status, error) {
                    $("#createUser").text("Create Game");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },

        searchRecord: function() {
            this.loadRecord = true;
            var str = this.search_match;
            var newString = str.indexOf("0") == 0 ? str.substring(1) : str;
            this.moreParams.filter = "254" + newString;
            this.$refs.vuetable.refresh();
        },

        dataManager(sortOrder, pagination) {
            if (this.data.length < 1) return;

            let local = this.data;

            // sortOrder can be empty, so we have to check for that as well
            if (sortOrder.length > 0) {
                console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
                local = _.orderBy(
                    local,
                    sortOrder[0].sortField,
                    sortOrder[0].direction
                );
            }

            pagination = this.$refs.vuetable.makePagination(
                local.length,
                this.perPage
            );
            console.log("pagination:", pagination);
            let from = pagination.from - 1;
            let to = from + this.perPage;

            return {
                pagination: pagination,
                data: _.slice(local, from, to)
            };
        },

        onPaginationData(paginationData) {
            this.$refs.paginationInfo.setPaginationData(paginationData);
            this.$refs.pagination.setPaginationData(paginationData);
        },

        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onLoading() {
            this.loading = true;
            console.log("loading... show your spinner here");
        },
        onLoaded() {
            this.loading = false;
            console.log("loaded! .. hide your spinner here");
            $(".ui.dropdown").dropdown();
        }
    },
    filters: {
        gamesStatus(value) {
            if (value == 1) {
                return "Active"
            } else {
                return "Disabled"
            }
        },
        gamesClassStatus(value) {
            if (value == '1') {
                return "green"
            } else {
                return "red"
            }
        },
        gameCategoryID(value) {
            if (value == 1) {
                return "Slot"
            } else if (value == 2) {
                return "Table"
            } else if (value == 3) {
                return "Virtuals"
            } else if (value == 4) {
                return "Live"
            } else if (value == 5) {
                return "Hot"
            } else {
                return "Most Popular"
            }
        },
    }
};
</script>
